<template>
    <div class="language-selector" :class="{'mr-3': $utils.isNotMobile()}">
        <v-menu :nudge-width="100" nudge-bottom="43">
            <template v-slot:activator="{ on }">
                <v-toolbar-title v-on="on" v-if="$utils.isMobile()">
                    <div class="m-item">{{ $appService.getLocale().toUpperCase() }}</div>
                </v-toolbar-title>
                <v-toolbar-title v-on="on" v-else>
                    <v-icon dark>language</v-icon>
                    <span class="ml-1">{{ languageMap[$i18n.locale] }}</span>
                </v-toolbar-title>
            </template>
            <v-list>
                <v-list-tile
                    v-for="item in availableLanguages"
                    :key="item.value"
                    @click="changeLanguage(item.value)"
                >
                    <v-list-tile-title
                        v-text="item.text"
                        :class="{active: $i18n.locale === item.value}"
                    ></v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
    </div>
</template>
<script>
export default {
    name: 'LanguageSelector',
    data() {
        let availableLanguages = [
            {value: 'en-US', text: 'English'},
            {value: 'vi-VN', text: 'Việt Nam'},
            {value: 'id-ID', text: 'Indonesia'},
            {value: 'jp-JP', text: '日本'}
        ]
        let languageMap = {}
        availableLanguages.forEach(item => {
            languageMap[item.value] = item.text
        })
        return {
            availableLanguages,
            languageMap,
            $utils: this.$utils
        }
    },
    mounted() {
        let language = this.$cookies.get(this.$const.LANGUAGE)
        if (!language) {
            language = this.getNavigatorLanguage()
        }
        if (this.languageMap[language]) {
            this.changeLanguage(language)
        }
    },
    methods: {
        changeLanguage(val) {
            this.$i18n.locale = val
            this.$cookies.set(this.$const.LANGUAGE, val)
        },
        getNavigatorLanguage() {
            if (navigator.languages && navigator.languages.length) {
                return navigator.languages[0]
            } else {
                return navigator.language || 'en-US'
            }
        }
    }
}
</script>
<style scoped lang="scss">
.language-selector {
    color: #000;
    cursor: pointer;
}

.language-selector /deep/ .v-toolbar__title {
    font-weight: normal;
    font-size: 14px;
    color: #fff;
    display: flex;
    align-items: center;
}

.v-list__tile__title {
    color: #000;
}

.active {
    color: #0052CC;
}

.m-item {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
}
</style>
